import firebase from 'firebase.js';
import CONSTANTS from 'utils/constants';
import { removeEmpty } from 'utils';

const getFirestoreRef = (path) => firebase.firestore().collection(path);

export const fetchDocument = async (collection, id) => {
  const document = await getFirestoreRef(collection).doc(id).get();
  if (!document.exists) {
    return null;
  }

  return { id: document.id, ...document.data() };
};

export const fetchCollection = async (collection, options = {}) => {
  const data = [];
  let baseQuery = getFirestoreRef(collection);
  baseQuery = baseQuery.where('status', '!=', CONSTANTS.STATUS_ENUM.ARCHIVED);

  if (options.queries) {
    const { queries } = options;
    queries.forEach(({ attribute, operator, value }) => {
      baseQuery = baseQuery.where(attribute, operator, value);
    });
  }

  if (options.sort) {
    const { attribute, order } = options.sort;
    baseQuery = baseQuery.orderBy(attribute, order);
  }
  (await baseQuery.get()).forEach((doc) =>
    data.push({ id: doc.id, ...doc.data() })
  );
  return data;
};

export const deleteDocument = (collection, id) => {
  return getFirestoreRef(collection).doc(id).delete();
};

export const createDocument = (collection, id, values) => {
  const newValues = removeEmpty({ ...values });
  if (!values.createdAt) {
    newValues.createdAt = new Date().toISOString();
  }
  if (!values.updatedAt) {
    newValues.updatedAt = new Date().toISOString();
  }
  if (!values.status) {
    newValues.status = CONSTANTS.STATUS_ENUM.CREATED;
  }

  if (!id) {
    return getFirestoreRef(collection)
      .add(newValues)
      .then((res) => {
        newValues.id = res.id;
        return getFirestoreRef(collection).doc(res.id).update({ id: res.id });
      })
      .then(() => {
        return newValues;
      })
      .catch((e) => {
        console.error('Failed to update id when creating document.', e);
      });
  }
  return getFirestoreRef(collection).doc(id).set(newValues);
};
export const updateDocument = (collection, id, values) => {
  const newValues = removeEmpty({ ...values });

  newValues.updatedAt = new Date().toISOString();

  return getFirestoreRef(collection).doc(id).update(newValues);
};

export const archiveDocument = (collection, id) => {
  const values = {
    status: CONSTANTS.STATUS_ENUM.ARCHIVED,
    archivedAt: new Date().toISOString(),
  };
  return updateDocument(collection, id, values);
};
